import { ButtonExcelForQuick } from 'components/DownloadExel'
import { Undo2 } from 'lucide-react'

import React from 'react'
import { FaYoutube } from 'react-icons/fa6'

const Heading = ({ title, download = "", handleBack = () => { }, showYouTubeIcon, youTubeOnClick = () => { } }) => {

    return (
        <div className="contentHead">
            <h4>{title}</h4>
            <div style={{display: 'flex', justifyContent:'space-between', alignItems: 'center', textAlign: 'center', gap: '8px'}}>
                {showYouTubeIcon && (
                    <div className="youtube_Icon" onClick={youTubeOnClick}>
                        <button><FaYoutube size={36} /></button>
                    </div>
                )}
                {title == "Create Trip" && <button className="rounded-icon-button" onClick={handleBack}>
                    <Undo2 size={20} className="rotate-icon" />
                </button>}
            </div>
        </div>
    )
}

export default Heading